// appStorage — the footage quota (A22) where the user actually MEETS it: the
// meter above uploading, and the block when a pack would not fit.
// Requested by P04 (INFO-P04-008). Keys mirror ../pl/appStorage.ts exactly.
//
// The "Storage" card in Billing has its own keys (`appBilling.storage.*`, requested
// by P01) — different screen, different conversation. The 90-day retention sentence
// lives ONLY there, so two versions of the same promise cannot drift apart.
export const appStorage = {
  meter: {
    label: 'Storage',
    used: '{used} of {quota}',
    full: 'Storage full',
    // Warn BEFORE the user uploads 4 GB and meets the error at the end of the bar.
    almostFull: '{free} left - a large file may not fit.',
  },
  upload: {
    blocked: 'This will not fit in your storage',
    blockedBody: 'You have {free} left. Delete footage you no longer use, or move to a higher plan.',
    manage: 'Manage footage',
    seePlans: 'See plans',
  },
  plan: {
    none: 'Without a plan you only have the storage that comes with the starter pack.',
  },
}
